<ng-container *ngIf="isVisible">
    <mat-icon
        [id]="field.id"
        [matTooltip]="field.tooltip ? (field.tooltip | translate) : ''"
        [ngClass]="[field.panelClass, isReadOnly || field.disabled ? 'disable-field' : '']"
        [attr.aria-disabled]="isReadOnly || field.disabled"
        (click)="onIconAction($event)"
    >
        {{ field.iconName }}
    </mat-icon>
</ng-container>
